/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_WidthInputs */

const en_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Width`)
};

const es_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancho de texto`)
};

const fr_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largeur du texte`)
};

const de_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textbreite`)
};

const ja_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの幅`)
};

const zh_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本宽度`)
};

const ar_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض النص`)
};

const id_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebar Teks`)
};

const it_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larghezza Testo`)
};

const ru_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ширина текста`)
};

const pt_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Largura do Texto`)
};

const ko_text_width = /** @type {(inputs: Text_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`텍스트 너비`)
};

/**
* | output |
* | --- |
* | "Text Width" |
*
* @param {Text_WidthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const text_width = /** @type {((inputs?: Text_WidthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_WidthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_text_width(inputs)
	if (locale === "es") return es_text_width(inputs)
	if (locale === "fr") return fr_text_width(inputs)
	if (locale === "de") return de_text_width(inputs)
	if (locale === "ja") return ja_text_width(inputs)
	if (locale === "zh") return zh_text_width(inputs)
	if (locale === "ar") return ar_text_width(inputs)
	if (locale === "id") return id_text_width(inputs)
	if (locale === "it") return it_text_width(inputs)
	if (locale === "ru") return ru_text_width(inputs)
	if (locale === "pt") return pt_text_width(inputs)
	return ko_text_width(inputs)
});